import { Component, Input } from '@angular/core';
import { GlobalServiceProvider} from "../../providers/global.service";

/**
 * Generated class for the HeaderbarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'majime-participant-group',
  templateUrl: 'majime-participant-group.html'
})
export class MajimeParticipantGroupComponent {

  @Input() config: object;

  text: string;

  constructor(public global:GlobalServiceProvider) {
    console.log('Hello MajimeParticipantGroupComponent Component');
    this.text = 'Hello World';
  }

  ngOnInit(){
    console.log("on init!");
    console.log("Config is ", JSON.stringify(this.config));
  }


  ionViewDidLoad(){
    
  }
}



// WEBPACK FOOTER //
// ./src/components/majime-participant-group/majime-participant-group.ts